const riot = require('riot');

riot.tag2('module-instagram', '<a class="row overflow-scroll mxn8" href="https://www.instagram.com/yoh_ueno.kemuri/" target="_blank"> <div class="col4 s-col6 square" each="{image in images}"> <div class="s-full p8"><img class="s-full object-fit-cover" riot-src="{image.url}" loading="lazy"></div> </div></a>', 'module-instagram,[data-is="module-instagram"]{display:block}', '', function(opts) {
    this.images = [
      {url: '/images/instagram/instagram_01.jpeg'},
      {url: '/images/instagram/instagram_02.jpeg'},
      {url: '/images/instagram/instagram_03.jpeg'},
      {url: '/images/instagram/instagram_04.jpeg'},
      {url: '/images/instagram/instagram_05.jpeg'},
      {url: '/images/instagram/instagram_06.jpeg'},
    ];
});